import { Box } from '@mui/material'
import LovField from 'features/lov/components/LovField'
import { useContext } from 'react'
import { ExpedientesContext } from '../../providers/ExpedientesProvider'

function ListOfValuesComponent({ columna, filtros, error }) {
  const {
    active: { current: tipo_expediente },
    campos_expediente,
    setCampoExpediente,
  } = useContext(ExpedientesContext)

  const campos = campos_expediente
  const campo = campos.filter((c) => c.columna === columna)[0]
  const valor = campo.valor

  const handleOnChange = (value) => {
    setCampoExpediente(campo, value, campo.validacion === 'S')
  }

  if (campo && campo.oculto !== 'S') {
    if (campo.tipo_input === 'lv') {
      return (
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            width: campo.ancho ? campo.ancho + '%' : '100%',
          }}
        >
          <LovField
            campo={campo}
            expediente={tipo_expediente.tipo_expediente}
            filtros={filtros}
            onValueChange={handleOnChange}
            error={error}
            value={valor === '' ? valor : undefined}
          />
        </Box>
      )
    }
  }
}

export default ListOfValuesComponent
